package pwgs.ui.scenes.projectmembersscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AProjectMembersControllerFe(props: pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneProps, scene: MProjectMembersScene)
 : AController<pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneProps, pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel, ProjectMembersSceneState>(props, scene) {

    val backend = ProjectMembersControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_removeMember(userId: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.removeMember(userId))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class ProjectMembersControllerBeProxy(private val controller: AProjectMembersControllerFe) {

    suspend fun load(): pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectmembersscene.ProjectMembersControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel.serializer())
        }
    }

    suspend fun removeMember(userId: kotlin.String): pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel {
        @Serializable
        class ParamsWrapper(val userId: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(userId))
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectmembersscene.ProjectMembersControllerBe.removeMember",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectmembersscene.ProjectMembersSceneModel.serializer())
        }
    }

}
